<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on }">
      <v-btn text class="px-1" v-on="on">
        {{ text }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Resend confirmation email
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email"
          label="E-mail"
          :error-messages="errors"
          required
          @keyup.enter="send"
          @blur="$v.email.$touch()"
        />
      </v-card-text>
      <v-card-text
        >Enter your email address, click send, and follow the instructions in
        the email we'll send you.</v-card-text
      >
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="
            dialog = false
            $v.$reset()
          "
        >
          Cancel
        </v-btn>
        <v-btn class="ma-2" depressed @click="send">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validationMixin } from "vuelidate"
import { required, email } from "vuelidate/lib/validators"
import { UtilService } from "@/services"
export default {
  mixins: [validationMixin],
  validations: {
    email: { email, required }
  },
  props: {
    text: {
      type: String,
      default: () => "Resend confirmation email ?"
    }
  },
  data() {
    return {
      dialog: false,
      email: ""
    }
  },
  computed: {
    errors() {
      const errors = []
      if (this.$v.email.$dirty) {
        if (!this.$v.email.email) {
          errors.push("E-mail n'est pas valide")
        }
        if (!this.$v.email.required) {
          errors.push("E-mail est requis")
        }
      }

      return errors
    }
  },
  methods: {
    send() {
      const self = this
      this.$v.$touch()
      if (!this.$v.$invalid) {
        UtilService.resendInvitation(self.email).then(r => {
          self.$store.commit("success", r.data)
          self.dialog = false
        })
      }
    }
  }
}
</script>
